// extracted by mini-css-extract-plugin
module.exports = {"modal_root":"ConfirmDialog_modal_root__3ClyJ","footer":"ConfirmDialog_footer__UfZQp"};